let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lXULr")).then(() => parcelRequire('15DL1'));